(function () {
  /**
   * @ngdoc module
   * @name binky.core.api.kmi
   * @description module that defines kmi api resource services
   */
  angular.module('binky.core.api.kmi', ['binky.core.api.utils', 'ngResource']);
})();
